import { render, staticRenderFns } from "./MachineDetails.vue?vue&type=template&id=e7bb908a"
import script from "./MachineDetails.vue?vue&type=script&lang=js"
export * from "./MachineDetails.vue?vue&type=script&lang=js"
import style0 from "./MachineDetails.vue?vue&type=style&index=0&id=e7bb908a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports